// @ts-nocheck
/* eslint-disable */
// first line is typescript syntax, but nobody seems to care
// second line is for the global tslint package
// to disable the tslint extension, exclude the file in settings
import {
  Component,
  EventEmitter,
  forwardRef,
  Input,
  ModuleWithProviders,
  NgModule,
  Output
} from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  ControlValueAccessor,
  NG_VALUE_ACCESSOR
} from '@angular/forms';

import { MatButtonModule } from '@angular/material/button';

// import { Observable } from 'rxjs';

import * as moment from 'moment';
// reference: http://momentjs.com/docs

const momentConstructor: (value?: any) => moment.Moment = (<any>moment).default || moment;


export const MD_CALENDAR_CONTROL_VALUE_ACCESSOR: any = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => MdCalendar),
  multi: true
};

const weekDays: string[] = [
  '', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday'
];

export type MdCalendarViewMode = ('month' | 'year' | 'decade');
export type MdCalendarPeriodType = ('day' | 'week' | 'month' | 'year');
export type MdCalendarEntryType = ('day' | 'month' | 'year');
export type MdCalendarWeekDay = (
  'monday' | 'tuesday' | 'wednesday' | 'thursday' | 'friday' | 'saturday' | 'sunday'
);
export type MdCalendarEntrySelectedState = ('none' | 'partial' | 'full' | 'invalid');

export class MdCalendarPeriod {
  type: MdCalendarPeriodType;
  startDate: Date;
  endDate: Date;
}

export class MdCalendarChange {
  source: MdCalendar;
  period: MdCalendarPeriod;
}

export class MdCalendarEntry {
  type: MdCalendarEntryType;
  date: Date;
  selected: MdCalendarEntrySelectedState;

  constructor(params: {
    type: MdCalendarEntryType,
    date: Date,
    selected: MdCalendarEntrySelectedState
  }) {
    this.type = params.type;
    this.date = params.date;
    this.selected = params.selected;
  }

  toString(): string {
    if (this.type == 'day') {
      return `${this.date.getDate()}`;
    }
    if (this.type == 'month') {
      return momentConstructor(this.date).format('MMM');
    }
    return `${this.date.getFullYear()}`;
  }

  getRange(): {start: moment.Moment, end: moment.Moment} {
    if (this.type == 'day') {
      let day: moment.Moment = momentConstructor(this.date);
      return {start: day, end: day};
    } else {
      var curMoment: moment.Moment = momentConstructor(this.date);
      return {
        start: curMoment.clone().startOf(this.type),
        end: curMoment.clone().endOf(this.type)
      };
    }
  }
}

@Component({
  moduleId: module.id,
  selector: 'md-calendar',
  templateUrl: './calendar.html',
  styleUrls: ['./calendar.scss'],
  providers: [MD_CALENDAR_CONTROL_VALUE_ACCESSOR]
})
export class MdCalendar implements ControlValueAccessor {
  private _viewDate: Date = new Date();
  // @ts-ignore
  private _viewMoment: moment.Moment = momentConstructor();
  private _viewHeader: string = '';

  private _onChangeCallback: (_: any) => void = (_: any) => {};
  // @ts-ignore
  private _onTouchedCallback: () => void = () => {};

  get viewDate(): Date { return this._viewDate; };
  @Input('view-date')
  set viewDate(viewDate: Date) { this._setViewDate(viewDate); }

  private _viewMode: MdCalendarViewMode = 'month';

  get viewMode(): MdCalendarViewMode { return this._viewMode; }
  @Input('view-mode')
  set viewMode(viewMode: MdCalendarViewMode) {
    this._viewMode = viewMode;
    this._buildCalendar();
  }

  private _weekMode = 'dddd';
  @Input('week-mode') set weekMode (val: string) {
    if (val === 'ddd' || val === 'dddd') {
      this._weekMode = val;
      this._buildMonthViewWeekDays();
    } else console.warn(`invalid week-mode: ${val}`);
  }

  private _startOfWeekDay: number = 1;
  get startOfWeekDay(): MdCalendarWeekDay {
    return <MdCalendarWeekDay>weekDays[this._startOfWeekDay];
  }
  @Input('start-of-week-day')
  set startOfWeekDay(weekDay: MdCalendarWeekDay) {
    this._startOfWeekDay = weekDays.indexOf(weekDay);

    (<any>moment).updateLocale(moment.locale(), { week: { dow: this._startOfWeekDay }});

    if (this._viewMode == 'month') {
      this._buildCalendar();
    }
  }

  private _selectionMode: MdCalendarPeriodType = 'day';
  get selectionMode(): MdCalendarPeriodType { return this._selectionMode; }
  @Input('selection-mode')
  set selectionMode(selectionMode: MdCalendarPeriodType) {
    this._selectionMode = selectionMode;
  }

  private _selectedDate: Date;
  get selectedDate(): Date { return this._selectedDate; };
  @Input('selected-date') set selectedDate(d: Date)  {
    if (d) {
      const p: MdCalendarPeriod = {
        type: this._selectionMode,
        startDate: new Date(momentConstructor(d).startOf(this._selectionMode).toDate().valueOf()),
        endDate: new Date(momentConstructor(d).endOf(this._selectionMode).toDate().valueOf())
      };
      if (this._selectedPeriod !== p) {
        this._selectedPeriod = p;
        this._refreshSelection();
      }
    } // selectedDate undefined, ignored
  }


  private _ymax = '2099';
  @Input('max-yyyy') set ymax (val: string) {
    if (/^2\d\d\d$/.test(val)) {
      this._ymax = val;
      this._buildCalendar();
    } else console.warn(`invalid max-yyyy: ${val}`);
  }
  private _mmax = '12';
  @Input('max-mm') set mmax (val: string) {
    if (/^(0[1-9]|1[012])$/.test(val)) {
      this._mmax = val;
      this._buildCalendar();
    } else console.warn(`invalid max-mm: ${val}`);
  }
  private _ymin = '2000';
  @Input('min-yyyy') set ymin (val: string) {
    if (/^2\d\d\d$/.test(val)) {
      this._ymin = val;

      this._buildCalendar();
    } else console.warn(`invalid min-yyyy: ${val}`);
  }
  private _mmin = '01';
  @Input('min-mm') set mmin (val: string) {
    if (/^(0[1-9]|1[012])$/.test(val)) {
      this._mmin = val;

      this._buildCalendar();
    } else console.warn(`invalid min-mm: ${val}`);
  }

  private _change: EventEmitter<MdCalendarChange> = new EventEmitter<MdCalendarChange>();
  /*
  @Output()
  public change(): Observable<MdCalendarChange> { return this._change.asObservable(); }
  */
  @Output() selDay: EventEmitter<string> = new EventEmitter<string>();
  @Output() selMonth: EventEmitter<string> = new EventEmitter<string>();
  @Output() selWeek: EventEmitter<string> = new EventEmitter<string>();

  private _selectedPeriod: MdCalendarPeriod;
  private set selectedPeriod(period: MdCalendarPeriod) {
    this._selectedPeriod = period;
    this._change.emit({
      source: this,
      period: period
    });
    this._refreshSelection();
  }

  get value(): MdCalendarPeriod { return this._selectedPeriod; }
  set value(period: MdCalendarPeriod) {
    if (period !== this._selectedPeriod) {
      this.selectedPeriod = period;
      this._onChangeCallback(period);
    }
  }

  public get calendarRows(): MdCalendarEntry[][] { return this._calendarRows; }
  public get viewHeader(): string { return this._viewHeader; }
  public get weekDays(): string[] { return this._weekDays; }

  public entryColor(state: MdCalendarEntrySelectedState, _entry: MdCalendarEntry): string {
    switch (state) {
      case 'none':
        return 'null';
      case 'invalid':
        return 'blue';
      default:
        return 'warn';
    }
  }

  private _calendarRows: MdCalendarEntry[][] = [];
  private _weekDays: string[] = [];

  // disable the prev/next buttons
  public prevDisable = false;
  public nextDisable = false;

  constructor() {
    this._buildCalendar();
  }

  prevPage(): void {
    if (this._viewMode == 'month') {
      this.viewDate = momentConstructor(this.viewDate).subtract(1, 'M').toDate();
    } else if (this._viewMode == 'year') {
      this.viewDate = momentConstructor(this.viewDate).subtract(1, 'y').toDate();
    } else if (this._viewMode === 'decade') {
      this.viewDate = momentConstructor(this.viewDate).subtract(10, 'y').toDate();
    }
    // this._buildCalendar();
    // set viewDate() will redraw calendar
  }

  nextPage(): void {
    if (this._viewMode == 'month') {
      this.viewDate = momentConstructor(this.viewDate).add(1, 'M').toDate();
    } else if (this._viewMode == 'year') {
      this.viewDate = momentConstructor(this.viewDate).add(1, 'y').toDate();
    } else if (this._viewMode === 'decade') {
      this.viewDate = momentConstructor(this.viewDate).add(10, 'y').toDate();
    }
    // this._buildCalendar();
    // set viewDate() will redraw calendar
  }

  previousViewMode(): void {
    if (this._viewMode == 'decade') {
      return;
    } else if (this._viewMode == 'year') {
      this._viewMode = 'decade';
    } else if (this._viewMode == 'month') {
      this._viewMode = 'year';
    }
    this._buildCalendar();
  }

  selectEntry(entry: MdCalendarEntry): void {
    /* ignore if entry is outside minmax range */
    if (entry.selected === 'invalid') return;

    if (!this._canSelectEntry(entry)) {
      return this._nextViewMode(entry);
    }

    let newPeriod: MdCalendarPeriod;
    if (false && this._isEntrySelected(entry) == 'full') {
      // assigning to null will remove the color from the selected button
      // newPeriod = null;
    } else if (this._selectionMode == 'day') {
      newPeriod = {
        type: 'day',
        startDate: entry.date,
        endDate: entry.date
      };
      this.selDay.emit(momentConstructor(entry.date).format('YYYY-MM-DD'));
    } else if (this._selectionMode == 'week') {
      newPeriod = {
        type: 'week',
        startDate: new Date(momentConstructor(entry.date).startOf('week').toDate().valueOf()),
        endDate: new Date(momentConstructor(entry.date).endOf('week').toDate().valueOf())
      };
      // @Output() selWeek = YYYY-MM-DD of start of week
      this.selWeek.emit(momentConstructor(entry.date).startOf('week').format('YYYY-MM-DD'));
    } else if (this._selectionMode == 'month') {
      newPeriod = {
        type: 'month',
        startDate: new Date(momentConstructor(entry.date).startOf('month').toDate().valueOf()),
        endDate: new Date(momentConstructor(entry.date).endOf('month').toDate().valueOf())
      };

      // @Output()selMonth = 'YYYY-MM'
      this.selMonth.emit(momentConstructor(entry.date).format('YYYY-MM'));
    } else if (this._selectionMode == 'year') {
      newPeriod = {
        type: 'year',
        startDate: new Date(momentConstructor(entry.date).startOf('year').toDate().valueOf()),
        endDate: new Date(momentConstructor(entry.date).endOf('year').toDate().valueOf())
      };
    }
    this.value = newPeriod;
  }

  registerOnChange(fn: (value: any) => void) {
    this._onChangeCallback = fn;
  }

  registerOnTouched(fn: any) {
    this._onTouchedCallback = fn;
  }

  writeValue(value: any) {
    this.selectedPeriod = value;
  }

  // private _getMonthName(date: Date): string {
  //   return momentConstructor(date).format('MMM');
  // }

  private _setViewDate(date: Date): void {
    this._viewDate = date;
    this._viewMoment = momentConstructor(date);
    // redraw calendar when viewDate is changed
    this._buildCalendar();
  }

  private _buildCalendar(): void {
    if (this._viewMode == 'month') {
      this._buildMonthView();
    } else if (this._viewMode == 'year') {
      this._buildYearView();
    } else if (this._viewMode == 'decade') {
      this._buildDecadeView();
    }
  }

  private _buildDecadeView(): void {
    let curYear: number = this._viewDate.getFullYear();
    let firstYear = curYear - (curYear % 10) + 1;
    let lastYear = firstYear + 11;

    this._viewHeader = `${firstYear} - ${lastYear}`;

    let curDate: moment.Moment = momentConstructor(this.viewDate)
      .startOf('year')
      .year(firstYear);

    this.prevDisable = (curDate.format('YYYY') <= this._ymin);

    let rows: MdCalendarEntry[][] = [];
    for (let i = 0 ; i < 4 ; i ++) {
      let row: MdCalendarEntry[] = [];
      for (let j = 0 ; j < 3 ; j ++) {
        let date = new Date(curDate.toDate().valueOf());
        let newEntry = new MdCalendarEntry({
          type: 'year',
          date: date,
          selected: 'none'
        });
        newEntry.selected = this._isEntrySelected(newEntry);
        row.push(newEntry);
        curDate.add(1, 'y');
      }
      rows.push(row);
    }
    this._calendarRows = rows;
    this.nextDisable = (curDate.format('YYYY') > this._ymax);
  }

  private _buildYearView(): void {
    this._viewHeader = `${this._viewDate.getFullYear()}`;

    let curDate: moment.Moment = momentConstructor(this.viewDate)
      .startOf('year');

    this.prevDisable = (curDate.format('YYYYMM') <= this._ymin + this._mmin);

    let rows: MdCalendarEntry[][] = [];
    for (let i = 0 ; i < 4 ; i ++) {
      let row: MdCalendarEntry[] = [];
      for (let j = 0 ; j < 3 ; j ++) {
        let date = new Date(curDate.toDate().valueOf());
        let newEntry = new MdCalendarEntry({
          type: 'month',
          date: date,
          selected: 'none'
        });
        newEntry.selected = this._isEntrySelected(newEntry);
        row.push(newEntry);
        curDate.add(1, 'M');
      }
      rows.push(row);
    }
    this._calendarRows = rows;
    this.nextDisable = (curDate.format('YYYYMM') > this._ymax + this._mmax);
  }

  private _buildMonthView(): void {
    this._viewHeader = momentConstructor(this._viewDate).format('MMM YYYY');

    this._buildMonthViewWeekDays();

    let viewStartDate: moment.Moment = momentConstructor(this.viewDate)
      .startOf('month')
      .startOf('week');
    this.prevDisable = (viewStartDate.format('YYYYMMDD') <= `${this._ymin}${this._mmin}01`);

    let viewEndDate: moment.Moment = momentConstructor(this.viewDate)
      .endOf('month')
      .endOf('week');

    let rows: MdCalendarEntry[][] = [];
    let curDate = momentConstructor(viewStartDate);
    while (curDate < viewEndDate) {
      let row: MdCalendarEntry[] = [];
      for (let i = 0 ; i < 7 ; i++) {
        let date = new Date(curDate.toDate().valueOf());
        let newEntry: MdCalendarEntry = new MdCalendarEntry({
          type: 'day',
          date: date,
          selected: 'none'
        });
        newEntry.selected = this._isEntrySelected(newEntry);
        row.push(newEntry);
        curDate.add(1, 'd');
      }
      rows.push(row);
    }
    this.nextDisable = (curDate.format('YYYYMM') > this._ymax + this._mmax);

    this._calendarRows = rows;
  }

  private _buildMonthViewWeekDays(): void {
    var curMoment = momentConstructor().startOf('week');
    let weekDayNames: string[] = [];
    for (let i = 0 ; i < 7 ; i++) {
      weekDayNames.push(curMoment.format(this._weekMode));
      curMoment.add(1, 'd');
    }
    this._weekDays = weekDayNames;
  }

  private _periodOrder(entryType: MdCalendarPeriodType): number {
    return ['day', 'week', 'month', 'year'].indexOf(entryType);
  }

  private _isEntrySelected(entry: MdCalendarEntry): MdCalendarEntrySelectedState {
    switch (entry.type) {
      // case 'day':
      case 'month':
        const ym = momentConstructor(entry.date).format('YYYY-MM');
        if (ym > `${this._ymax}-${this._mmax}` ||  ym < `${this._ymin}-${this._mmin}`) {
          return 'invalid';
        }
        break;
      case 'year':
        const y = momentConstructor(entry.date).format('YYYY');
        if (y > this._ymax ||  y < this._ymin) {
          return 'invalid';
        }
        break;
    }
    if (this._selectedPeriod != null) {
      let selectionStart: moment.Moment = momentConstructor(this._selectedPeriod.startDate)
        .startOf('day');
      let selectionEnd: moment.Moment = momentConstructor(this._selectedPeriod.endDate)
        .endOf('day');
      let selectionPeriodOrder: number = this._periodOrder(this._selectedPeriod.type);

      let entryPeriodOrder: number = this._periodOrder(entry.type);
      let entryRange: {start: moment.Moment, end: moment.Moment} = entry.getRange();

      if (entryPeriodOrder <= selectionPeriodOrder &&
        entryRange.start.isBetween(selectionStart, selectionEnd, null, '[]') &&
        entryRange.end.isBetween(selectionStart, selectionEnd, null, '[]')
      ) {
        return 'full';
      } else if (entryPeriodOrder > selectionPeriodOrder &&
        selectionStart.isBetween(entryRange.start, entryRange.end, null, '[]') &&
        selectionEnd.isBetween(entryRange.start, entryRange.end, null, '[]')
      ) {
        return 'partial';
      }
    }

    return 'none';
  }

  private _refreshSelection(): void {
    for (let row of this._calendarRows) {
      for (let entry of row) {
        entry.selected = this._isEntrySelected(entry);
      }
    }
  }

  private _canSelectEntry(entry: MdCalendarEntry): boolean {
    if (['day', 'week'].indexOf(this._selectionMode) >= 0 && entry.type != 'day') {
      return false;
    }
    if (this._selectionMode == 'month' && entry.type == 'year') {
      return false;
    }
    return true;
  }

  private _nextViewMode(entry: MdCalendarEntry): void {
    if (this._viewMode == 'decade') {
      this._viewMode = 'year';
    } else if (this._viewMode == 'year') {
      this._viewMode = 'month';
    } else if (this._viewMode == 'month') {
      return;
    }
    this.viewDate = entry.date;
    // this._buildCalendar();
    // set viewDate() will redraw calendar
    // but direct assignment to the private _viewDate will not
    // fix: was assignment to this._viewDate, which won't redraw
  }
}

export const MD_CALENDAR_DIRECTIVES = [MdCalendar];

@NgModule({
  imports: [CommonModule, MatButtonModule],
  exports: [MdCalendar],
  declarations: [MdCalendar],
  providers: []
})
export class MdCalendarModule {
  static forRoot(): ModuleWithProviders<MdCalendarModule> {
    return {
      ngModule: MdCalendarModule,
      providers: []
    };
  }
}
